/**
 * Poll until `predicate()` returns true. Works without Zone.js and avoids
 * `toObservable()` in route guards (which must not call `inject()` after `await`).
 */
export function waitUntilPredicate(
  predicate: () => boolean,
  options?: { timeoutMs?: number; intervalMs?: number }
): Promise<void> {
  const timeoutMs = options?.timeoutMs ?? 30_000;
  const intervalMs = options?.intervalMs ?? 16;
  const deadline = Date.now() + timeoutMs;

  return new Promise((resolve, reject) => {
    const step = (): void => {
      try {
        if (predicate()) {
          resolve();
          return;
        }
        if (Date.now() >= deadline) {
          reject(new Error('waitUntilPredicate: timeout'));
          return;
        }
        globalThis.setTimeout(step, intervalMs);
      } catch (e) {
        reject(e);
      }
    };
    step();
  });
}
